// extracted by mini-css-extract-plugin
export default {"description":"Tabs_description__fgLEs","reactPlayer":"Tabs_reactPlayer__czo8X","wrapper":"Tabs_wrapper__7u+Nc"};